/*
 * Ryan O'Dowd
 * 2021-03-06
 * © Copyright 2021 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({windowWidth}) => {
  return {
    container: {
      flex: 1,
    },
    links: {
      display: 'flex',
      flexGrow: 1,
      flexWrap: 'wrap',
      flexDirection: windowWidth < 450 ? 'column' : 'row',
      gap: 8,
    },
    link: {
      flex: 1,
      minWidth: 135,
      minHeight: 40,
      width: 135,
      height: 40,
      maxWidth: 135,
      maxHeight: 40,
    },
    linkImage: {
      alignSelf: 'center',
      width: 135,
      height: 40,
    },
  };
};

export default getStyles;
